/**
 * Group — Group model for organizing nodes
 * Per PLAN.md models/Group.js and PRD §4.5
 */

export class Group {
    /**
     * Create a new group
     * @param {string[]} nodeIds - Array of node IDs in this group
     * @param {string} name - Optional group name
     */
    constructor(nodeIds = [], name = null) {
        this.id = crypto.randomUUID();
        this.name = name;
        this.nodeIds = [...nodeIds];
        this.createdAt = Date.now();
    }

    /**
     * Add a node to the group
     * @param {string} nodeId 
     */
    addNode(nodeId) {
        if (!this.nodeIds.includes(nodeId)) {
            this.nodeIds.push(nodeId);
        }
    }

    /**
     * Remove a node from the group
     * @param {string} nodeId 
     */
    removeNode(nodeId) {
        const index = this.nodeIds.indexOf(nodeId);
        if (index > -1) {
            this.nodeIds.splice(index, 1);
        }
    }

    /**
     * Check if group contains a node
     * @param {string} nodeId 
     * @returns {boolean}
     */
    hasNode(nodeId) {
        return this.nodeIds.includes(nodeId);
    }

    /**
     * Get number of nodes in group
     * @returns {number}
     */
    size() {
        return this.nodeIds.length;
    }

    /**
     * Check if group is empty
     * @returns {boolean}
     */
    isEmpty() {
        return this.nodeIds.length === 0;
    }

    /**
     * Serialize to JSON
     * @returns {Object}
     */
    toJSON() {
        return {
            id: this.id,
            name: this.name,
            nodeIds: [...this.nodeIds],
            createdAt: this.createdAt
        };
    }

    /**
     * Create group from JSON
     * @param {Object} data 
     * @returns {Group}
     */
    static fromJSON(data) {
        const group = new Group(data.nodeIds, data.name);
        group.id = data.id;
        group.createdAt = data.createdAt || Date.now();
        return group;
    }
}
